export class AuthLinkService {
	private swapAuthLinksInRoot(root: Document | ShadowRoot, logPrefix: string): number {
		let count = 0
		const elements = root.querySelectorAll('[data-auth-href]')
		elements.forEach((element: HTMLElement) => {
			console.log(`${logPrefix} Element Detected to Swap: ${element}\n`)
			const authHref = element.getAttribute('data-auth-href')
			if (authHref && authHref !== 'undefined') {
				element.setAttribute('href', authHref)
				count++
			}
		})
		return count
	}

	swapLinks(): void {
		let swappedLinks = 0
		console.log(`Begin Swap Link Process...\n`)
		// Swap Non-Shadow Elements
		swappedLinks += this.swapAuthLinksInRoot(document, 'Non-Shadow')
		// Swap Shadow Elements in gb-global-nav
		const globalNav = document.querySelector('gb-global-nav')
		const shadowRootNav = globalNav && globalNav.shadowRoot
		if (shadowRootNav) {
			swappedLinks += this.swapAuthLinksInRoot(shadowRootNav, 'Shadow (Nav)')
		}
		// Swap Shadow Elements in gb-global-footer
		const globalFooter = document.querySelector('gb-global-footer')
		const shadowRootFooter = globalFooter && globalFooter.shadowRoot
		if (shadowRootFooter) {
			swappedLinks += this.swapAuthLinksInRoot(shadowRootFooter, 'Shadow (Footer)')
		}
		console.log(`Swap Link Process Completed\nLinks Swapped: ${swappedLinks}`)
	}
}
